export default "__VITE_ASSET__a30f7212__$_?nuxt_component=async&nuxt_component_name=SvgoFreeethereum__"